<div class="d-flex justify-content-around">
  <div class="d-flex align-items-center">{{customElement.dependency}} </div>
  <button nbButton status="primary" (click)="abrirDepencencias()">
      <nb-icon icon="sitemap" pack="font-awesome"></nb-icon>
      </button>
</div>